import { render, staticRenderFns } from "./upload-bank-accounts.vue?vue&type=template&id=2685daf4&"
import script from "./upload-bank-accounts.vue?vue&type=script&lang=js&"
export * from "./upload-bank-accounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2685daf4')) {
      api.createRecord('2685daf4', component.options)
    } else {
      api.reload('2685daf4', component.options)
    }
    module.hot.accept("./upload-bank-accounts.vue?vue&type=template&id=2685daf4&", function () {
      api.rerender('2685daf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/beneficiary/upload-bank-accounts.vue"
export default component.exports